import GeneralHeader from "src/components/Sections/General/GeneralHeader/GeneralHeader";
import AsyncMotors from "src/components/Sections/Services/AsyncMotors/AsyncMotors";
import SyncMotors from "src/components/Sections/Services/SyncMotors/SyncMotors";
import DirectCurrentMotors from "src/components/Sections/Services/DirectCurrentMotors/DirectCurrentMotors";
import SpareParts from "src/components/Sections/Services/SpareParts/SpareParts";
import BulkWinding from "src/components/Sections/Services/BulkWinding/BulkWinding";
import FieldWork from "src/components/Sections/Services/FieldWork/FieldWork";
import OurServices from "src/components/Sections/Services/OurServices/OurServices";
import OtherServices from "src/components/Sections/Services/OtherServices/OtherServices";

const Services = () => (
    <>
      <GeneralHeader />
      <OurServices />
      <AsyncMotors />
      <SyncMotors />
      <DirectCurrentMotors />
      <SpareParts />
      <BulkWinding />
      <FieldWork />
      <OtherServices />
    </>
  );

export default Services;